import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'register',
  templateUrl: 'register.component.html',
  styleUrls: ['./register.component.scss']
})

export class RegisterComponent implements OnInit {
  step = '1';
  loading = false;
  errors = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['step']) {
        this.step = params['step'];
      } else {
        this.router.navigate(['/register/step/1']);
      }
      console.log('this.step: ', this.step);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts